(function (angular) {
	'use strict';

	angular.module('PinMeTo.directives').component('pmtProvinceDropdown', {
		templateUrl: 'pmtShared/directives/pmtProvinceDropdown.html',
		controller: Dropdown,
		bindings: {
			selectedValue: '<',
			onSelectedValueChanged: '<',
			emptyDefault: '<'
		}
	});

	Dropdown.$inject = ['countryData', 'pmtAlertService'];

	function Dropdown(countryData, pmtAlertService) {
		let $ctrl = this;
		$ctrl.selectedProvince = { selected: { name: $ctrl.selectedValue } };
		$ctrl.provinces = [];

		this.compareProvinces = (a, b) => {
			return a != null && b != null && a.name === b.name;
		};

		this.showProvinceInDropDown = x => {
			if (x != null) {
				if (x.name) {
					return x.name;
				} else {
					return x;
				}
			} else {
				return 'Selected item is undefined!';
			}
		};

		this.$onChanges = function () {
			let update = angular.copy($ctrl.selectedProvince);
			update.selected = { name: $ctrl.selectedValue };
			$ctrl.selectedProvince = update;
		};

		let displayAlert = function (title, body) {
			pmtAlertService.alert({
				title: title,
				body: body,
				confirmTitle: 'Ok',
				confirm: function () {
					pmtAlertService.close();
				}
			});
		};

		countryData
			.getCountryData()
			.then(data => {
				$ctrl.provinces = data.provinces;
				$ctrl.$onChanges();
			})
			.catch(err => displayAlert('Error', err.data.toString()));
	}
})(window.angular);
